













import { Vue, Component, Prop } from 'vue-property-decorator';
import { BillingType } from '../utils/billing-type.enum';

@Component
export default class SelectBillingType extends Vue {
  @Prop({
    type: String,
    default: BillingType.SINGLE,
  }) billingType!: string;

  types = [
    { value: BillingType.SINGLE, description: 'Único' },
    { value: BillingType.RETROACTIVE, description: 'Retroativo' },
  ]

  change(typeSelected: string) {
    this.$emit('change', typeSelected);
  }
}
